$(document).ready(function() {
    $(".mob-hamburger button").click(function() {
        $(this).toggleClass("active"), $(".header-angle").toggleClass("active"), $(".header-pages ul").toggleClass("active")
    }), $(document).on("click", "form.search-form.search-page-form , .s-icon", function() {
        $(this).find("input").prop("disabled", !0), $(this).parents(".header-search").find("details-modal.header__search details").prop("open", !0), $("body").css("overflow", "hidden")
    }), $(document).on("click", "details[open] .modal-overlay", function() {
        $(this).parents(".header-search").find("details-modal.header__search details").prop("open", !1), setTimeout(function() {
            $("form.search-form.search-page-form input").prop("disabled", !1), $("body").css("overflow", "unset")
        }, 200)
    }), $(".dropdown .dropdown-button .r-arrow1").click(function() {
      if($(this).parents('.dropdown').find('.dropdown-content a').length > 0){
        $(this).parents('.dropdown').toggleClass("active");
      }
    }), $(".home-banner .banner").owlCarousel({
        loop: !0,
        margin: 10,
        nav: !0,
        navText: ["<i class='fa-solid fa-arrow-left'></i>", "<i class='fa-solid fa-arrow-right'></i>"],
        dots: !1,
        autoplay: true,
        autoPlaySpeed: 3000,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 1
            },
            1000: {
                items: 1
            }
        }
    }), $(".wireless").owlCarousel({
        loop: !0,
        margin: 15,
        nav: !0,
        dots: !1,
        navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
        responsive: {
            0: {
                items: 1.5
            },
            600: {
                items: 2.5
            },
            1000: {
                items: 4.5
            }
        }
    }), $(".reveiews").owlCarousel({
        loop: !0,
        margin: 15,
        nav: !0,
        navText: ["<i class='fa-solid fa-arrow-left'></i>", "<i class='fa-solid fa-arrow-right'></i>"],
        dots: !1,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 3
            },
            1000: {
                items: 3
            }
        }
    }), $(".slider-box").owlCarousel({
        loop: !0,
        autoplay: !1,
        nav: !0,
        dots: !0,
        navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
        responsive: {
            0: {
                items: 3
            },
            600: {
                items: 4
            },
            1000: {
                items: 5
            }
        }
    }), $(".menu-top-searc input , .menu-top-searc svg").click(function() {
        setTimeout(function() {
            $(".header__icon--search").trigger("click")
        }, 100)
    }), 1 == $("body.template--product").length && ($(document).on("click", ".size-chart-label", function() {
        $("#myModal").attr("style", "display:block"), $(this).addClass("Modal-open")
    }), $(document).on("click", ".modal-content .close", function() {
        $("#myModal").attr("style", "display:none !important"), $(".size-chart-label").removeClass("Modal-open")
    })), $(".header-width").click(function(e) {}), screen.width > 992 ? $(".header-width").hover(function() {
        $(this).toggleClass("active"), $(".menus").toggleClass("zoomIn")
    }) : $(".vertical-head-main").click(function(e) {
        e.preventDefault(), $(this).parents(".header-width").toggleClass("active"), 
        $(this).parents(".header-main-flex").find(".vertical-slider-blk.mob-ver .menus").toggleClass("zoomIn")
    }), $(window).width() < 991 && ($(".menus>ul>li>a").click(function(e) {
        return $(this).parent().find(".mega-menu-content").slideToggle(), $(this).parent().siblings().children().next().slideUp(), !1
    }), $(".menus>ul>li>a").click(function(e) {
        e.preventDefault(), $(this).parent(".menus>ul>li").toggleClass("active"), $(this).parent(".menus>ul>li").siblings(".menus>ul>li").removeClass("active")
    })), 1 == $("body.template--product").length && $(".product__info-wrapper .product__accordion details .summary__title h2").each(function() {
        if ("description" == $(this).text().trim().toLowerCase()) {
            var e = $(this).parents(".product__accordion").find("details summary");
            $(e).trigger("click")
        }
    }), 
      
      window.addEventListener("load", function() {
        var e = 0;
        $(".slider-width").each(function() {
            $(this).height() > e && (e = $(this).height())
        }), $(".slider-width").height(e)
    })
      
      , $(".slider-content .owl-carousel").owlCarousel({
        loop: !0,
        margin: 0,
        nav: !0,
        dots: !1,
        center: !1,
        autoplay: !0,
        navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
        responsive: {
            0: {
                center: !0,
                items: 1
            },
            767: {
                items: 2
            },
            1000: {
                items: 2.9
            }
        }
    });
      var maxHeight = 0;
      $(".wireless-sub .detail-box").each(function(){
         if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
      });
      $(".wireless-sub .detail-box").height(maxHeight);
      $(".dropdown-inner .r-arrow1").click(function() {
      if($(this).parents('.dropdown-inner').find('.dropdown-content-inner a').length > 0){
        $(this).parents('.dropdown-inner').toggleClass("active")
      }
    })

   $('.headder-products-flex').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 9,
    slidesToScroll: 9,
    arrows:true,
    prevArrow:"<button type='button' role='presentation' class='owl-prev'><i class='fa-solid fa-arrow-left'></i></button>",
     nextArrow:"<button type='button' role='presentation' class='owl-next'><i class='fa-solid fa-arrow-right'></i></button>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 700,
        settings: "unslick"
      }
    ]
  });
  

  $('.shop-brand-flex').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 5,
    arrows:true,
    prevArrow:"<button type='button' role='presentation' class='owl-prev'><i class='fa-solid fa-arrow-left'></i></button>",
     nextArrow:"<button type='button' role='presentation' class='owl-next'><i class='fa-solid fa-arrow-right'></i></button>",
    responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          arrows:false
        }
      },
      {
        breakpoint: 589,
        settings: {
          slidesToShow: 2.3,
          slidesToScroll: 2,
          infinite: true,
          dots: false,
          arrows:false
        }
      }
    ]
  });

  
});

